import { MAIN_STYLE, MAIN_STYLE_GROUPS, PADDING_SIDES, BUTTON_MATRIX_EVENTS } from '../shared.js'
export const btnmatrix = {
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
                padding: { type: 'int', min: 0, exportSpecial: true },
                ...PADDING_SIDES,
                // pad_inner is a single real LVGL style value controlling the inter-button gap
                // (lv_btnmatrix.c:162-166) — distinct from the 4-side edge "padding" above, so it
                // is exported generically as pad_inner (not via the padding/exportSpecial
                // shorthand). Not yet wired into HaspButtonmatrix.js's rendering (the canvas
                // currently hardcodes a fixed 5px inter-button gap via `this.buttPadding`,
                // unrelated to this property) — that wiring is a separate Phase 4 task.
                pad_inner: { type: 'int', min: 0, label: 'inner padding' },
            },
        },
        item_buttons: {
            label: 'Item Buttons',
            exportSuffix: '40',
            order: 1,
            properties: {
                bg_color:         { type: 'color' },
                border_color:     { type: 'color' },
                border_width:     { type: 'int', min: 0 },
                radius:           { type: 'int', min: 0, max: 999 },
                text_color:       { type: 'color' },
                text_font:        { type: 'int', min: 8, label: 'Size (px)' },
                text_font_family: { type: 'string', internal: true },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        toggle:    { type: 'bool' },
        one_check: { type: 'bool' },
        align:     { type: 'enum', values: ['left', 'center', 'right', 'auto'] },
        options:   { type: 'array' },
        groupid:   { type: 'int', min: 0, max: 15, exportSpecial: true },
        entityid:  { type: 'string', internal: true },
        // Font Family selection for the item buttons' text — see label.js's
        // `font` property comment for the full wire-format semantics (same
        // convention: its value is the literal wire-format string written to
        // `text_font40` verbatim, see Exporter._processFonts()).
        font: { type: 'resource', resourceType: 'font', label: 'Font Family', inline: true },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 250, height: 100, min_width: 100, min_height: 40,
            enabled: true, hidden: false,
            one_check: false, toggle: false,
            options: ['Btn1', 'Btn2', 'Btn3', '\n', 'Btn4', 'Btn5'],
            font: '',
        },
        styles: {
            // Part defaults — padding drives button layout, item_buttons.text_font
            // drives button labels. padding matched against lv_theme_hasp.c's real edge
            // padding (shared pad_small/pad_inner styles, not zero).
            main: { padding: 10 },
            item_buttons: { text_color: '#ffffff', text_font_family: 'Roboto Condensed', text_font: 32 },
        },
    },
    states: ['checked', 'pressed', 'pressedChecked', 'disabled', 'disabledChecked'],
    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu'],
    runtimeCapabilities: ['has_action', 'has_group'],

    events: BUTTON_MATRIX_EVENTS,

    bindings: {
        properties: {},
        actions: {
            hass_services: ['', 'homeassistant', 'openhasp', 'automation', 'climate', 'light', 'switch', 'scene', 'esphome'],
        },
        events: {},
    },
}

export const mtrx_btn = {
    parts: {},

    properties: {
        text: { type: 'string' },
    },

    defaults: { properties: {} },

    editorCapabilities:  ['no_haspid', 'no_comment', 'no_gridsnap', 'no_export'],
    runtimeCapabilities: ['no_touch', 'no_hidde'],

    events: {},
    bindings: { properties: {}, actions: {}, events: {} },
}
